<template>
  <nav class="mobile-bottom-nav">
    <div v-if="this.startWith=='dashboard'" class="mobile-bottom-nav-item  mobile-bottom-nav-item--active" @click.prevent="dashboard">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/home.png">
        Accueil
      </div>
    </div>
    <div v-else class="mobile-bottom-nav-item" @click.prevent="dashboard">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/home.png">
        Accueil
      </div>
    </div>

    <div v-if="this.startWith=='dossier'" class="mobile-bottom-nav-item  mobile-bottom-nav-item--active" @click.prevent="file">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/files.png">
        Dossier
      </div>
    </div>
    <div v-else class="mobile-bottom-nav-item" @click.prevent="file">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/files.png">
        Dossier
      </div>
    </div>

    <div v-if="this.startWith=='messages'" class="mobile-bottom-nav-item  mobile-bottom-nav-item--active" @click.prevent="messages">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/message.png">
        Messages
      </div>
    </div>
    <div v-else class="mobile-bottom-nav-item" @click.prevent="messages">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/message.png">
        Messages
      </div>
    </div>

    <div v-if="this.startWith=='profil'" class="mobile-bottom-nav-item  mobile-bottom-nav-item--active" @click.prevent="profil">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/profile.png">
        Profil
      </div>
    </div>
    <div v-else class="mobile-bottom-nav-item" @click.prevent="profil">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/profile.png">
        Profil
      </div>
    </div>

    <div class="mobile-bottom-nav-item" @click.prevent="logOut">
      <div class="mobile-bottom-nav-item-content">
        <img src="@/assets/img/navbar/logout.png">
        Quitter
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MobileNavbar",
  data() {
    return {
      startWith: null
    }
  },
  methods: {
    dashboard() {
      this.$router.push({name: 'dashboard'});
      this.startWith = 'dashboard'
    },
    file() {
      this.$router.push({name: 'file'});
      this.startWith = 'dossier'
    },
    messages() {
      this.$router.push({name: 'messages'});
      this.startWith = 'messages'
    },
    profil() {
      this.$router.push({name: 'profil'});
      this.startWith = 'mon-profil'
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push({name: 'public-login'});
    },
    mouseOver(button) {
      document.getElementById(button + 'Text').innerHTML = 'Prochainement'
    },
    mouseOut(button) {
      document.getElementById(button + 'Text').innerHTML = button
    }
  },
  mounted() {
    if (this.$route.fullPath.startsWith("/dashboard")) this.startWith = 'dashboard'
    if (this.$route.fullPath.startsWith("/dossier")) this.startWith = 'dossier'
    if (this.$route.fullPath.startsWith("/messages")) this.startWith = 'messages'
    if (this.$route.fullPath.startsWith("/mon-profil")) this.startWith = 'profil'
  }
};
</script>